{
  "hero": {
    "eyebrow": "项目",
    "title": "打造雷达辅助、半自主的表水路水质监测机器人。",
    "lead": "AquaWorks 是由不列颠哥伦比亚大学学生开发的学生主导工程项目，面向受控静水环境——并在获批时面向温哥华校园低风险水域——构建可复用的、与位置关联的水质观测平台。"
  },
  "purpose": {
    "title": "总体目标",
    "body": "让水质状况更易于观察、理解与传达。每个阶段建立在上一阶段之上：环境适应性、自主性、数据价值与研究潜力逐步提升。"
  },
  "phases": {
    "title": "发展路线图",
    "items": {
      "phase1": {
        "label": "第一阶段",
        "title": "雷达辅助静水监测",
        "body": "以远程操控为主，辅以低速路径跟随与障碍距离感知。核心传感器、CSV 日志、路线图与至少一幅空间可视化。当前 AMS SPF 申请重点。",
        "window": "2026 年 9–12 月 · 2027 年 1 月报告"
      },
      "phase2": {
        "label": "第二阶段",
        "title": "近岸线性监测",
        "body": "面向获批近岸路线（例如某排放口参考点两侧）。改进防搁浅或半两栖结构、GPS 跟踪、导航稳定性与通信距离——须经许可与安全审查。"
      },
      "phase3": {
        "label": "第三阶段",
        "title": "区域自主监测",
        "body": "在选定近岸区域进行网格或热点路线，增强两栖能力，并支持定向采样以供后续实验室分析复杂污染物。"
      }
    }
  },
  "objectives": {
    "title": "第一阶段目标",
    "items": [
      { "title": "稳定的模块化浮体机器人", "body": "一体原型：浮力、防水、推进、载荷与岸边回收。" },
      { "title": "模块化传感系统", "body": "温度、pH、浊度、电导率与溶解氧，并形成校准或验证记录。" },
      { "title": "控制、通信与同步记录", "body": "可靠遥控、无线或本地存储，时间戳与空间参考同步，雷达距离写入日志。" },
      { "title": "数据处理与可视化", "body": "CSV 导出、路线图、趋势图与至少一幅空间水质可视化。" },
      { "title": "分阶段验证", "body": "从台架到受控水体集成；校园水体测试仅在许可与安全批准后进行。" },
      { "title": "完整项目档案", "body": "CAD、布线、软件、校准、安全、维护与最终报告（2027 年 1 月 31 日前）。" }
    ]
  },
  "system": {
    "title": "五个协同子系统",
    "lead": "机械浮体平台、电气与电源、水质传感、推进与控制、以及数据记录与可视化。",
    "workflow": "路线规划 → 部署前检查 → 下水 → 遥控或半自主运行 → 测量 → 时间与位置记录 → 存储或传输 → 回收 → 校验 → 可视化。",
    "items": [
      { "title": "机械平台", "body": "稳定船体或多浮体、模块化载荷区、防水舱、传感器与推进安装、回收点。" },
      { "title": "电气与电源", "body": "可充电电池、稳压、电机驱动、微控制器、防护布线、电量监测与紧急隔离。" },
      { "title": "水质传感", "body": "可互换指标用于刻画一般条件——非特定污染物的实验室确证。" },
      { "title": "推进与控制", "body": "远程为主；雷达辅助距离感知。人工接管始终可用。" },
      { "title": "数据与可视化", "body": "保留原始文件；生成地图与曲线，假设清晰、缺口有标记。" }
    ]
  },
  "scope": {
    "title": "第一阶段范围内",
    "body": "2026 年 9 月 1 日至 12 月 31 日设计、建造、集成并验证小型模块化机器人用于受控静水运行；最终报告于 2027 年 1 月 31 日前完成。",
    "sourceTitle": "公开项目事实",
    "sourceBody": "AMS 可持续项目基金申请。计划周期：2026 年 9 月 1 日–12 月 31 日。最终报告于 2027 年 1 月 31 日前提交 AMS Sustainability Office。本站不公布具体资助金额。"
  },
  "outOfScope": {
    "title": "第一阶段不包含",
    "items": [
      "完全自主导航或复杂任务规划",
      "开阔水域、海岸、急流或恶劣天气作业",
      "半两栖/防搁浅作为必交付能力",
      "自动采样或实验室级污染物检测",
      "法规、饮用水或公共卫生监测",
      "无人长期部署或未经场地批准的测试"
    ]
  },
  "principles": {
    "title": "设计原则",
    "items": [
      { "title": "模块化", "body": "传感器与主要部件可更换，无需重建整机。" },
      { "title": "可维修", "body": "可检查、维护、更换与排障，并有清晰文档。" },
      { "title": "安全优先", "body": "低速、目视监督、人工接管与可靠回收优先于高级自主。" },
      { "title": "数据可追溯", "body": "原始读数、校准、处理步骤与试验条件均有记录。" }
    ]
  },
  "timeline": {
    "title": "第一阶段计划时间线",
    "items": {
      "sep": { "label": "2026.09", "title": "立项与验证", "body": "确定需求、CAD、电气架构、传感方案、安全流程与部件检查。" },
      "oct": { "label": "2026.10", "title": "子系统建造", "body": "制造平台；台架测试电子；建立传感、控制与日志软件模块。" },
      "nov": { "label": "2026.11", "title": "集成与受控水体", "body": "浮力、防水、推进、校准，以及首批同步数据集与可视化流水线。" },
      "dec": { "label": "2026.12", "title": "全系统验证", "body": "受控水体测试；若许可与条件允许，可选获批校园静水演示。" },
      "jan": { "label": "2027.01", "title": "报告与交接", "body": "最终报告、技术档案、维护指南与后续阶段建议。" }
    }
  },
  "disclaimer": {
    "title": "诚实边界",
    "body": "AquaWorks 不替代专业环境评估、法规监测或认证实验室检测。它是面向空间学习、初步观测与可复用技术基础的学生平台。"
  },
  "cta": {
    "primary": "探索科学背景",
    "secondary": "认识团队"
  }
}
